import { Dropdown } from 'antd';
import React, { useEffect } from 'react';
import { CheckIcon, DownIcon } from './components/SvgIcons/SvgIcons';

const CustomSelect = ({
  handleCheckAll,
  handleCheckActive,
  handleCheckCompleted,
  checkAll,
  checkActive,
  checkCompleted,
  handleGetMyBounties,
  filter,
}) => {
  return (
    <div className="custom-menu">
      <Dropdown
        overlay={
          <SelectList
            handleCheckAll={handleCheckAll}
            handleCheckActive={handleCheckActive}
            handleCheckCompleted={handleCheckCompleted}
            checkAll={checkAll}
            checkActive={checkActive}
            checkCompleted={checkCompleted}
            handleGetMyBounties={handleGetMyBounties}
            filter={filter}
          />
        }
        placement="bottomRight"
        trigger={["click"]}
      >
        {checkAll ? (
          <button className="active-btn">
            View All
            <DownIcon />
          </button>
        ) : checkActive ? (
          <button className="active-btn">
            Active
            <DownIcon />
          </button>
        ) : (
          <button className="active-btn">
            Completed
            <DownIcon />
          </button>
        )}
      </Dropdown>
    </div>
  );
};

export default CustomSelect;

export const SelectList = ({
  handleCheckAll,
  handleCheckActive,
  handleCheckCompleted,
  checkAll,
  checkActive,
  checkCompleted,
  handleGetMyBounties,
  filter
}) => {
  useEffect(() => {
    handleGetMyBounties();
  }, [filter])
  return (
    <div className="select-list-wrapper">
      <div className="select-list-menu" onClick={() => handleCheckAll()}>
        {checkAll ? <CheckIcon /> : null}
        <p>View all</p>
      </div>
      <div className="select-list-menu" onClick={() => handleCheckActive()}>
        {checkActive ? <CheckIcon /> : null} <p>Active</p>
      </div>
      <div className="select-list-menu" onClick={() => handleCheckCompleted()}>
        {checkCompleted ? <CheckIcon /> : null} <p>Completed</p>
      </div>
    </div>
  );
};
